var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useCallback } from 'react';
import { Input } from 'semantic-ui-react';
import { ChevronDownIcon, ChevronUpIcon } from '../../Icon';


var NumberInput = function (_a) {
    var _b = _a.value, value = _b === void 0 ? '0' : _b, onChange = _a.onChange, onFocus = _a.onFocus, onBlur = _a.onBlur, name = _a.name, icon = _a.icon, className = _a.className, placeholder = _a.placeholder, label = _a.label, error = _a.error, _c = _a.loading, loading = _c === void 0 ? false : _c, _d = _a.disabled, disabled = _d === void 0 ? false : _d, input = _a.input, minimum = _a.minimum, maximum = _a.maximum, baseInputProps = __rest(_a, ["value", "onChange", "onFocus", "onBlur", "name", "icon", "className", "placeholder", "label", "error", "loading", "disabled", "input", "minimum", "maximum"]);
    var classNames = ['pluggy', 'floating-label-input', 'NumberInput'];
    if (error) {
        classNames.push('has-error');
    }
    if (value !== undefined) {
        classNames.push('filled');
    }
    if (className) {
        classNames.push(className);
    }
    var combinedClassNames = classNames.join(' ');
    var handleChange = useCallback(function (value) {
        var numericValue = Number(value);
        if ((minimum !== undefined && numericValue < minimum) ||
            (maximum !== undefined && numericValue > maximum)) {
            return;
        }
        onChange({ value: value });
    }, [onChange]);
    var handleInputChange = useCallback(function (_, _a) {
        var value = _a.value;
        handleChange(value);
    }, [handleChange]);
    var handleIncrement = useCallback(function () {
        handleChange(String(Number(value) + 1));
    }, [value, handleChange]);
    var handleDecrement = useCallback(function () {
        handleChange(String(Number(value) - 1));
    }, [value, handleChange]);
    var handleKeyDown = useCallback(function (_a) {
        var key = _a.key;
        if (key === 'ArrowUp') {
            handleIncrement();
        }
        else if (key === 'ArrowDown') {
            handleDecrement();
        }
    }, [handleIncrement, handleDecrement]);
    return (React.createElement(Input, __assign({}, baseInputProps, { type: 'text', value: value, onChange: handleInputChange, onFocus: onFocus, onBlur: onBlur, className: combinedClassNames, placeholder: placeholder, loading: loading, disabled: disabled, input: input, labelPosition: 'right', label: React.createElement("label", { className: 'floating-label' }, label), icon: React.createElement("div", { className: 'increment-arrows' },
            React.createElement("button", { onClick: handleIncrement },
                React.createElement(ChevronUpIcon, { size: "12", className: disabled ? 'disabled' : '' })),
            React.createElement("button", { onClick: handleDecrement },
                React.createElement(ChevronDownIcon, { size: "12", className: disabled ? 'disabled' : '' }))), error: Boolean(error), onKeyDown: handleKeyDown })));
};
export { NumberInput };
